export default __webpack_public_path__ + "static/media/iconos-12.c5132209.png";